import React, { FunctionComponent, JSX } from "react";
import Icon from "@ant-design/icons";
import { IIcon } from "./icons-interfaces";

const HiddenSvg = () => (
  <svg fill="currentColor" width="1em" height="1em" viewBox="0 0 48 48">
    <path d="M47.13,24.01c-3.59-3.69-7.24-6.51-10.91-8.46l5.91-5.91c.78-.78.78-2.05,0-2.83-.78-.78-2.05-.78-2.83,0l-7.01,7.01c-3.34-1.2-6.69-1.69-10.06-1.44C9.79,13.28,2.04,23.78,1.72,24.23c-.61.84-.48,2,.3,2.68,3.38,2.97,6.82,5.26,10.29,6.89l-5.76,5.76c-.78.78-.78,2.05,0,2.83.39.39.9.59,1.41.59s1.02-.2,1.41-.59l6.99-6.99c2.85.91,5.73,1.36,8.61,1.36.61,0,1.22-.02,1.84-.06,12.28-.82,20.07-9.61,20.39-9.98.68-.78.65-1.96-.08-2.71ZM30.06,24.43c0,3.06-2.49,5.54-5.54,5.54-.8,0-1.56-.17-2.25-.48l7.31-7.31c.31.69.48,1.45.48,2.24ZM19.45,26.66c-.3-.68-.47-1.44-.47-2.23,0-3.06,2.49-5.54,5.54-5.54.79,0,1.55.17,2.23.47l-7.3,7.3ZM6.15,25.16c1.98-2.18,6.32-6.29,12.22-8.03-2.08,1.75-3.4,4.37-3.4,7.29,0,1.91.57,3.68,1.54,5.17l-1.17,1.17c-3.08-1.27-6.14-3.14-9.19-5.61ZM30.03,32.2c2.43-1.73,4.03-4.57,4.03-7.77,0-1.91-.57-3.69-1.54-5.18l.7-.7c3.21,1.52,6.43,3.8,9.63,6.87-2.12,1.93-6.66,5.44-12.82,6.79Z" />
  </svg>
);

const HiddenIcon: FunctionComponent<IIcon> = (props): JSX.Element => (
  <Icon className={props.className} component={HiddenSvg} />
);

export default HiddenIcon;
